import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusSquare, faPlusSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

const ThreeWayCheckbox = ({ onChange, readOnly, type, defaultValue }) => {
    const value = defaultValue.toString();
    const iconTrue = type === "filter" ? faPlusSquare : faCheck;
    const iconFalse = type === "filter" ? faMinusSquare : faTimes;
    const iconEmpty = type === "filter" ? faSquare : null;

    const handleClick = () => {
        const newValue = value === "true" ? "false" : value === "false" ? "" : "true";
        onChange(newValue);
    };

    const icon = value === "true" ? iconTrue : value === "false" ? iconFalse : iconEmpty;

    const attrs = readOnly
        ? {}
        : {
              onClick: handleClick,
          };

    return <div {...attrs}>{icon && <FontAwesomeIcon icon={icon} />}</div>;
};

export default ThreeWayCheckbox;
